import CameraCapture from './camera-capture';

export default CameraCapture;